/** Human-readable MB label from a byte limit (integer MB or one decimal). */
export function formatMaxFileSizeMbLabel(maxBytes: number): string {
    const mb = maxBytes / (1024 * 1024);
    return Number.isInteger(mb) ? String(mb) : mb.toFixed(1);
}

export function maxFileSizeErrorText(maxBytes: number): string {
    return `File size must be less than ${formatMaxFileSizeMbLabel(maxBytes)} MB.`;
}

export function maxFileSizeHintText(maxBytes: number): string {
    return `Maximum file size: ${formatMaxFileSizeMbLabel(maxBytes)} MB per file.`;
}
